<template>
  <div>
    <div v-if="validRoute() && clientData && !isMobile" class="client-name">
      <v-avatar
        :color="colors[clientData.name[0]]"
        size="24"
      >
        <img v-if="clientAvatar !== undefined" :src="clientAvatar.link" alt="">
        <span v-else class="white--text initials">{{ clientData.name | initials }}</span>
      </v-avatar>
      <span> {{ getActiveClientName() }} </span>
    </div>
    <div v-if="activeRoute.name == 'agent-invite-client'">
      <div class="mobile-layout-content">
        <router-view />
      </div>
    </div>
    <div v-else>
      <div :class="{'layout-content': activeRoute && activeRoute.name !== 'agent-search' && activeRoute.name !== 'communication'}">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { routeNamesForClientSearch } from '../../utils/generalConsts'
import avatarColors from '../../utils/avatarColors'

export default {
  filters: {
    initials: function(value) {
      if (!value) return ''
      value = value.split(' ')
      let response = ''
      for (const v of value) {
        response = response + v.charAt(0).toUpperCase()
      }
      return response
    }
  },
  data() {
    return {
      colors: avatarColors,
      clientAvatar: ''
    }
  },
  computed: {
    ...mapState('home', ['activeRoute']),
    ...mapState('common', ['isMobile']),
    ...mapState('client', ['clientData']),
    pathInArrayForm() {
      if (this.$route.name === undefined) {
        return []
      }
      var arr = []
      this.$route.name.split('/').map(val => {
        val = val.replace('-', ' ')
        arr.push({ text: val })
      })
      return arr
    }
  },
  methods: {
    validRoute() {
      return routeNamesForClientSearch.includes(this.activeRoute.name)
    },
    getActiveClientName() {
      if (this.clientData) {
        this.clientAvatar = this.clientData && this.clientData.media
          ? this.clientData.media.find(item => item.type === 'avatar') : undefined
        return this.clientData.name
      }
      return null
    },
    redirectToRouteByPath(pathName) {
      var i = this.pathInArrayForm.findIndex(item => item.text === pathName)
      var fullPath = ''
      for (let j = 0; j <= i; j++) {
        fullPath += this.pathInArrayForm[j].text + '/'
      }
      this.$router.push({ path: fullPath })
    }
  }
}
</script>

<style lang="sass">
.top-wrapper
  display: grid
  width: 100%
  grid-template-areas: "page-name client-name ..."
  grid-template-columns: 1fr 1fr 1fr
  grid-gap: 2%
  text-transform: capitalize

.page-name
  background: transparent
  color: $hwayzBlack

// @Toolbar style
.mobile-layout-content
  background: white
  height: 100%

.navigation-toggle
  .v-btn__content
    i
      color: $hwayzBlack

// @Sidebar content
.v-list
  padding-bottom: 0 !important

.navigation-toggle--menu
  .v-btn__content
    i
      color: $hwayzWhite !important

.sidebar-link .v-list__tile__action, .v-list__tile__avatar
  min-width: 40px !important
#sidebar .v-list__tile__title
    font-size: 12px
    font-family: Roboto,sans-serif
    color: rgba(0, 0, 0, 0.87)

@media only screen and (max-width: 600px)
    margin-top: 2rem !important
    .v-list__tile__content, .v-list__tile__title
      font-size: 12px
      font-family: Roboto,sans-serif
    .sidebar-submenu__link div, .v-list__tile div, #sidebar .v-list__tile__title
      font-size: 12px !important
      font-family: Roboto,sans-serif
.sidebar-submenu__link div
  width: 100%

.opacity-zero
  opacity: 0

.opacity-one
  opacity: 1
  transition: opacity 0.5s ease

// @Content style

.client-name
  background: transparent
  color: $hwayzBlack
  padding-top: 16px !important

#breadcrumbs
  text-transform: capitalize
  color: $hwayzBlack
  padding-left: 20px !important
  padding-top: 16px !important
  padding-bottom: 20px !important

.layout-content
  @media only screen and (min-width: 600px)
    padding: 0
  @media only screen and (min-width: 960px)
    padding: 1rem !important
.initials
  font-size: 1.2rem
</style>
